<template>
  <page-layout
    :breadcrumbs="[
      {
        text: this.$t('navDrawer.home').toUpperCase(),
        disabled: false,
        to: {name: 'home'},
        exact: true
      },
      {
        text: textoTipoSolicitudes.toUpperCase(),
        disabled: true
      }
    ]"
  >
    <v-layout justify-center wrap mb-5 v-if="selectedItems.length >= 1">
      <transition-group style="text-align:center;" name="fade">
        <v-btn class="ma-1" :key="7" color="primary" :disabled="waitingForLoadTablas" :loading="waitingForLoadTablas" @click="selectAll(false)">
          <!-- <v-icon left>mdi-card-text-outline</v-icon> -->
          <v-icon left>mdi-file-document-box-remove-outline</v-icon>
          {{ $t('deseleccionar') }}
        </v-btn>
        <v-btn color="primary" :key="1" border="primary" class="ma-1"
          dark style="min-width: 230px !important; max-width: 230px;"
          :disabled="selectedItems.length > 1"
          @click="goDetail(selectedItems[0]['id'])">
          <v-icon class="pr-2">remove_red_eye</v-icon>
          {{ $t('detalle') }}
        </v-btn>
        <v-btn color="primary" :key="2" border="primary" class="ma-1"
          dark style="min-width: 230px !important; max-width: 230px;"
          @click="modifyStateArray()" :disabled="disableUpdate"
          v-if="this.permitirModificarEstado()">
          <v-icon class="pr-2">compare_arrows</v-icon>
          {{ $t('modificarEstado') }}
        </v-btn>

        <v-btn color="primary" :key="3" border="primary" class="ma-1"
          dark style="min-width: 230px !important; max-width: 230px;"
          @click="cambiarTipoSolicitud()" :disabled="comprobarDeshabilitarCambioTipo()" v-if="!this.rolProveedor && !this.rolCliente">
          <v-icon class="pr-2">import_export</v-icon>
          {{ $t('modificarTipo') }}
        </v-btn>

        <v-btn color="primary" :key="4" border="primary" class="ma-1"
          dark style="min-width: 230px !important; max-width: 230px;"
          @click="enviarParteArray()" :disabled="comprobarDeshabilitarParte()" v-if="!this.rolCliente">
          <v-icon class="pr-2">send</v-icon>
          {{ $t('enviarParte') }}
        </v-btn>
        <v-btn color="primary" :key="5" border="primary" class="ma-1"
          dark style="min-width: 230px !important; max-width: 230px;"
          @click="deleteArrayItems()" v-if="permitirEliminarSolicitudProveedor()">
          <v-icon class="pr-2">delete</v-icon>
          {{ $t('eliminar') }}
        </v-btn>

        <v-menu offset-y :key="6" v-if="!this.rolProveedor && !this.rolCliente">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" border="primary" class="ma-1"
              dark style="min-width: 230px !important; max-width: 230px;"
              v-on="on">
              <v-icon class="pr-2">mdi-file-pdf</v-icon>
              {{ $t('fichaPDF') }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in fichasPDF"
              :key="index" @click="cargaFichaPDF(item.tipo)">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </transition-group>
    </v-layout>

    <v-layout justify-center wrap mb-5 v-if="selectedItems.length < 1">
      <transition-group style="text-align:center;" name="fade">
        <v-btn class="ma-1" :key="4" color="primary" :disabled="waitingForLoadTablas" :loading="waitingForLoadTablas" @click="selectAll(true)">
          <!-- <v-icon left>mdi-card-text</v-icon> -->
          <v-icon left>mdi-file-document-box-plus-outline</v-icon>
          {{ $t('seleccionar')}}
        </v-btn>
        <v-btn color="primary" :key="1" border="primary" class="ma-1"
          dark style="min-width: 230px !important; max-width: 230px;"
          @click="importarIncidencias()" v-if="!this.rolProveedor && !this.rolCliente">
          <v-icon class="pr-2">mdi-import</v-icon>
          {{ $t('importarIncidencias') }}
        </v-btn>
        <v-btn color="primary" :key="1" border="primary" class="ma-1"
          dark style="min-width: 230px !important; max-width: 230px;"
          @click="importarDocumentos()" v-if="!this.rolCliente">
          <v-icon class="pr-2">mdi-import</v-icon>
          {{ $t('importarDocumentos') }}
        </v-btn>
        <v-btn color="primary" :key="2" border="primary" class="ma-1"
          dark style="min-width: 230px !important; max-width: 230px;"
          @click="cargarFlexmonster()" v-if="!this.rolProveedor && !this.rolCliente">
          <v-icon>mdi-table-eye</v-icon>
          <span v-show="!flexmonster">{{ $t('tablaDinamica') }}</span>
          <span v-show="flexmonster">{{ textoTipoSolicitudes }}</span>
        </v-btn>
        <v-btn class="ma-1" :key="3" color="primary" :disabled="waitingForLoadTablas" :loading="waitingForLoadTablas" @click="configurarTabla" v-if="!this.rolProveedor && !this.rolCliente">
          <v-icon left>mdi-playlist-edit</v-icon>
          {{cambiandoColumnas ? (heCambiadoColumnas ? $t('guardarCambios') : $t('volver')) : $t('configurarTabla') }}
        </v-btn>
      </transition-group>
    </v-layout>
    <div v-if="cambiandoColumnas" style="position: relative;" class="pt-2 pl-2 pr-2 pb-0">
      <draggable xs12 v-model="headersTablaOrden" id="headersTablaOrden">
        <v-chip
          v-for="(header) in cabecerasDisponibles(headersTabla)"
          :key="'columna' + header.codigoColumna"
          class="mt-0 mb-1 mx-1 elevation-0"
          outlined
          color="primary"
          label
          small
          style="cursor: pointer; height: 40px"
        >
          <v-icon left small color="primary">mdi-cursor-move</v-icon>
          <span style="font-weight: bold" :class="header.ocultada ? 'grey--text' : 'primary--text'">{{header.text !== '' ? header.text : $t('imagen_estado')}}</span>
          <v-icon
            v-if="header.ocultable"
            right
            small
            color="primary"
            @click="headersTabla[header.orden].ocultada = !header.ocultada; heCambiadoColumnas = true"
          >
            {{header.ocultada ? 'mdi-eye-off' : 'mdi-eye'}}
          </v-icon>
        </v-chip>
      </draggable>
      <v-divider class="primary" style="border-width: 2px 0 0 0;margin-top:1px;"/>
      <v-row class="pa-2" justify="center" style="position: absolute;bottom:-60px;margin:auto;left:0;right:0;">
        {{ $t('activarDesactivarVisibilidadColumnas') }}
      </v-row>
    </div>
    <v-layout justify-center wrap mb-1>
    <v-row v-if="visualizarFiltroEvaluado === true">
      <v-col cols="9"></v-col>
      <v-col cols="3">
        <v-autocomplete
          md4
          v-model="storeFilters.evaluada"
          id="evaluada"
          :items="optionsSelectEvaluated"
          item-value="value"
          label="Filtro"
          density="compact"
          clearable
          @change="filterByEvaluada()"
        />
      </v-col>
    </v-row>
  </v-layout>
    <v-layout v-show="!flexmonster" v-if="!cambiandoColumnas">
      <v-flex lg12>
        
        <v-layout justify-center>
          <v-data-table ref="tabla" :headers="headersFiltrados" :items="getIncidencesList" v-model="selectedItems" id="selectedItems"
            item-key="id" class="text-xs-center" :loading="waitingForLoad" :options="customPagination"
            :footer-props="{
              'items-per-page-text': $t('filasPorPagina'),
              'items-per-page-options': this.pagination,
              'show-current-page': true
            }"
            :show-current-page="true"
            loading-text="this.$t('cargandoDatos')"
            @update:items-per-page="itemPerPage"
            @update:page="getPage($event)"
            :hide-default-headers="cambiandoColumnas"
            :custom-sort="customSort"
          >
            <template v-for="h in headers" v-slot:[`header.${h.value}`]="{ headers }">
              <v-tooltip left :key="h.id" v-if="h.tooltip">
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{h.text}}</span>
                </template>
                <v-list class="lista-tooltip">
                  <v-list-item>
                    <v-icon color="primary lighten-1">mdi-hammer</v-icon>
                    &nbsp;{{ $t('incidencia') }}
                  </v-list-item>
                  <v-list-item>
                    <v-icon color="primary lighten-1">mdi-phone</v-icon>
                    &nbsp;{{ $t('comercial') }}
                  </v-list-item>
                  <v-list-item>
                    <v-icon color="primary lighten-1">mdi-file-document-outline</v-icon>
                    &nbsp;{{ $t('administrativa') }}
                  </v-list-item>
                  <v-list-item>
                    <v-icon color="primary lighten-1">mdi-help-circle-outline</v-icon>
                    &nbsp;{{ $t('otras') }}
                  </v-list-item>
                </v-list>
              </v-tooltip>
              <v-tooltip bottom :key="h.id" v-if="!h.tooltip">
                <template v-slot:activator="{ off }">
                  <span v-on="off">{{h.text}}</span>
                </template>
              </v-tooltip>
            </template>
            <template
              v-slot:body="{ items }">
              <tbody>
                <!-- @dblclick="countSelected ? dobleClick($event, item.id) : null" -->
                <tr v-for="item in items"
                  :key="item.id"
                  @click="(dialog || dialogDelete) ? null : oneClick(item)"
                  @dblclick="countSelected && !oneClick() ? dobleClick($event, item.id) : null"
                  @mouseover="countSelected ? mouseOver(item) : null"
                  @mouseleave="countSelected ? mouseLeave() : null"
                  :style="{
                    opacity: cambiandoColumnas ? 0 : 1,
                    'pointer-events': cambiandoColumnas ? 'none' : 'auto',
                    'background-color': selectedItems.some(x => x.id === item.id) ? 'lightgray' : ''
                  }"
                >
                  <!-- <td><v-checkbox v-model="selectedItems" id="selectedItems" :value="item" :key="'checkbox'"></v-checkbox></td> -->
                  <template v-for="(header, index) in headersFiltrados">
                    <td :style="getStyle(header.value)"
                      seleccionable="true"
                      :class="header.classTd"
                      class="text-xs-center recortarStyle"
                      :key="'td-' + item.id + '-' + header.value"
                      @mouseover.native="countSelected ? mouseOver(item) : null"
                      @mouseleave.native="countSelected ? mouseLeave() : null"
                    >
                      <template v-if="selectedItems.length === 0 && itemEncima === item.id && index === headersFiltrados.length - 1">
                        <v-layout row justify-center>
                          <v-flex class="clickable text-xs-center" @click="goDetail(item.id)">
                            <v-icon color="#2c61a0" small :title="$t('detalle')">remove_red_eye</v-icon>
                          </v-flex>
                          <v-flex class="clickable text-xs-center" @click="modifyState(item)" v-if="permitirModificarEstado()">
                            <v-icon color="#2c61a0" small :title="$t('modificarEstado')">compare_arrows</v-icon>
                          </v-flex>
                          <v-flex class="clickable text-xs-center" @click="deleteItem(item.id, item.statusCode)" v-if="permitirEliminarSolicitudProveedor()">
                            <v-icon color="#2c61a0" small :title="$t('eliminar')">delete</v-icon>
                          </v-flex>
                        </v-layout>
                      </template>
                      <template v-else-if="header.value === 'img'">
                        <v-icon :color="calculaColorEstado(item)">{{ imagenes[item.statusCode].icono }}</v-icon>
                        <v-tooltip bottom v-if="item.pendientes && item.pendientes > 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" class="badge">
                            {{item.pendientes}}
                          </v-btn>
                          </template>
                          <span>{{ $t('chat.mensajesPendientes') }}</span>
                        </v-tooltip>
                      </template>
                      <!--<template v-else-if="header.value === 'id'" >{{ item.id }}</template>-->
                      <template v-else-if="header.value === 'id'" >{{ item.referencia }}</template>
                      <template v-else-if="header.value === 'visitaReferencia'" >{{ item.visitaReferencia }}</template>
                      <template v-else-if="header.value === 'state'">{{ getState(item) }}</template>
                      <template v-else-if="header.value === 'nombreResponsable'">{{ item.nombreResponsable.trim() }}</template>
                      <template v-else-if="header.value === 'idSolicitud' && item.idSolicitud === '1'">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary lighten-1" v-on="on" style="cursor: pointer;">mdi-hammer</v-icon>
                          </template>
                          <span>{{ $t('incidencia') }}</span>
                        </v-tooltip>
                      </template>
                      <template v-else-if="header.value === 'idSolicitud' && item.idSolicitud === '2'">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary lighten-1" v-on="on" style="cursor: pointer;">mdi-file-document-outline</v-icon>
                          </template>
                          <span>{{ $t('administrativa') }}</span>
                        </v-tooltip>
                      </template>
                      <template v-else-if="header.value === 'idSolicitud' && item.idSolicitud === '3'">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary lighten-1" v-on="on" style="cursor: pointer;">mdi-phone</v-icon>
                          </template>
                          <span>{{ $t('comercial') }}</span>
                        </v-tooltip>
                      </template>
                      <template v-else-if="header.value === 'idSolicitud' && item.idSolicitud === '4'">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary lighten-1" v-on="on" style="cursor: pointer;">mdi-help-circle-outline</v-icon>
                          </template>
                          <span>{{ $t('otras') }}</span>
                        </v-tooltip>
                      </template>
                      <template v-else-if="header.value === 'nombrePromocion'">{{ item.nombrePromocion }}</template>
                      <template v-else-if="header.value === 'location'">
                        <v-tooltip right>
                          <template v-slot:activator="{ on }">
                            <span v-on="on" style="cursor: pointer;" v-html="item.location.replace('<br>', ' ')" class="nowrap"/>
                          </template>
                          <span v-html="item.location"/>
                        </v-tooltip>
                      </template>
                      <template v-else-if="header.value === 'room'">{{ traducirLocalizacion(item) }}</template>
                      <template v-else-if="header.value === 'description'">
                        <v-tooltip right>
                          <template v-slot:activator="{ on }">
                            <span v-on="on" style="cursor: pointer;">{{ item.description }}</span>
                          </template>
                          <span>{{ item.description }}</span>
                        </v-tooltip>
                      </template>
                      <template v-else-if="header.value === 'proveedor'">{{ mostrarProveedorConCodigo(item)  }}</template>
                      <template v-else-if="header.value === 'profession'">
                        <v-tooltip right>
                          <template v-slot:activator="{ on }">
                            <span v-on="on" style="cursor: pointer;">{{ traducirOficio(item) }}</span>
                          </template>
                          <span>{{ traducirOficio(item) }}</span>
                        </v-tooltip>
                      </template>
                      <template v-else-if="header.value === 'openDate'">{{ item.openDate }}</template>
                      <template v-else-if="header.value === 'notificationDate'">{{ item.notificationDate }}</template>
                      <template v-else-if="header.value === 'fechaEscrituracion' && idubapi.motor !== 'SIN_BD'">{{ item.fechaEscrituracion }}</template>
                      <template v-else-if="header.value === 'vistoBueno'">{{ pintarVB(item) }}</template>
                      <template v-else-if="header.value === 'origenCierre'">{{ pintarOrigen(item.origenCierre) }}</template>
                      <template v-else-if="header.value === 'sector'">{{ item.sector }}</template>
                      <template v-else-if="header.value === 'poblacion'">{{ item.poblacion }}</template>
                      <template v-else-if="header.value === 'promProvincia'">{{ item.promProvincia }}</template>
                      <template v-else-if="header.value === 'valorCP' && idubapi.motor !== 'SIN_BD'">{{ item.valorCP }}</template> 
                      <template v-else-if="header.value === 'urgencia'">{{ item.urgencia }}</template> 
                      <template v-else-if="header.value === 'fechaPrevista'">{{ item.fechaFinPrevisto }}</template> 
                    </td>
                  </template>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-layout>
        <v-fade-transition>
          <custom-dialog
            v-if="dialog"
            v-model="dialog" id="dialog"
            @aceptar="dialog = $event"
          >
            <PopUpCambiarEstado
              :singleItem="singleItem"
              :estadoOrigen="estadoOrigen"
              :incidenceIds="selectedItems"
              @updateData="setNuevoEstado($event)"
            />
          </custom-dialog>
        </v-fade-transition>
        <FormDuplicar v-model="dialogDuplicar" id="dialogDuplicar" />
        <FormEnviarParte :incidenceIds="selectedItems" v-model="dialogEnviarParte" id="dialogEnviarParte"
          @msgSuccessEnviarParte="addSuccessMsgEnviarParte()" />
        <FormImportar v-model="dialogImportar" id="dialogImportar" @reload="loadConFiltros(filtrosParaUsar)"/>
        <FormImportarDocumentos v-model="dialogImportarDocumentos" id="dialogImportarDocumentos" @reload="loadConFiltros(filtrosParaUsar)" @verHistorico="verHistorico" />

        <FormHistorico v-model="dialogHistorico" id="dialogHistorico" @close="dialogHistorico = false; dialogImportarDocumentos = true" />


        <FormFichaPDF :tipoDeFicha="tipoFicha" :incidenceIds="selectedItems" v-model="dialogFichaPDF" id="dialogFichaPDF" />
        <Filters
          ref="filters"
          v-if="!rolProveedor"
          :filtros="filtrosParaUsar"
          @valoresFiltros="loadConFiltros($event)"
        />
        <FiltrosRolProveedor
          ref="filters"
          v-if="rolProveedor"
          :filtros="filtrosParaUsar"
          @valoresFiltros="loadConFiltros($event)"
        />

        <ConfirmDialog :text="$t('deseaContinuar')"
          @cancel="dialogParte = false" :dialogFlag="dialogParte" @close="dialogEnviarParte = true, dialogParte = false"
          :textoBoton="textoAceptarDialogParte" :textoTitulo="textoTituloDialogParte" />

          <v-fade-transition>
          <custom-dialog
            v-if="dialogCambiarTipo"
            v-model="dialogCambiarTipo" id="dialogCambiarTipo"
            @aceptar="dialogCambiarTipo = $event"
          >
            <PopUpCambiarTipo
              :solicitud="selectedItems[0]"
              @updateData="setNuevoTipo($event)"
            />
          </custom-dialog>
        </v-fade-transition>
      </v-flex>
    </v-layout>

    <div id="pivotContainer" v-show="flexmonster"></div>

    <ConfirmDialog
      :text="textoConfirmacion"
      :textoTitulo="$t('eliminar')"
      :textoBoton="$t('eliminar')"
      :dialogFlag="dialogDelete"
      @close="confirmarBorrado()"
      @cancel="dialogDelete = false"
    />
  </page-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Filters from './filters'
import FiltrosRolProveedor from './filtrosRolProveedor'
import ConfirmDialog from '../custom/confirmDialog'
import FormDuplicar from './formularios/formDuplicar'
import FormEnviarParte from './formularios/formEnviarParte'
import FormImportar from './formularios/formImportarIncidencia'
import FormImportarDocumentos from './formularios/formImportarDocumentos'
import FormHistorico from './formularios/formHistorico'
import FormFichaPDF from './formularios/formFichaPDF'
import 'flexmonster/flexmonster.min.css'
import Flexmonster from 'flexmonster'
import PopUpCambiarEstado from './formularios/PopUpCambiarEstado'
import PopUpCambiarTipo from './formularios/PopUpCambiarTipo'
import draggable from 'vuedraggable'
import _ from 'lodash'

import licenciaFlexmonster from '../../../config/flexmonster.js'

export default {
  components: {
    Filters,
    FiltrosRolProveedor,
    ConfirmDialog,
    FormDuplicar,
    FormEnviarParte,
    FormImportar,
    FormImportarDocumentos,
    FormFichaPDF,
    PopUpCambiarEstado,
    draggable,
    PopUpCambiarTipo,
    FormHistorico,
  },
  props: {
    filters: {
      type: Object,
      default: () => null
    },
    codigoTipo: {
      type: String,
      default: null
    }
  },
  beforeCreate () {
    document.documentElement.classList.add('showScrollbar2')
  },
  data () {
    return {
      dialogParte: false,
      textoAceptarDialogParte: this.$t('verIncidencia').dialogConfirmacion.boton,
      textoTituloDialogParte: '',
      showTooltip: false,
      pagination: [],
      waitingForLoad: true,
      flexmonster: false,
      selectedItems: [],
      disableDetail: false,
      disableUpdate: false,
      dialog: false,
      singleItem: [],
      estadoOrigen: "0",
      dialogDuplicar: false,
      dialogUpdate: false,
      dialogEnviarParte: false,
      dialogImportar: false,
      dialogImportarDocumentos: false,
      dialogHistorico: false,
      dialogDelete: false,
      textoConfirmacion: '',
      itemId: [], // lo hacemos array para poder borrar masivamente
      loader: null,
      dialogFichaPDF: false,
      tipoFicha: 'I',
      datosNuevoEstado: null,
      lastItemPerPage: null,
      // filtros: null,
      fichasPDF: [
        { title : this.$t('fichaIncidencia'), tipo: 'I' },
        { title : this.$t('fichaVisita'), tipo: 'V' },
        { title : this.$t('incidenciasCerradas'), tipo: 'C' }
      ],
      imagenes: {
        10 : {icono: 'build', color: '#E7D123', colorPasado: '#D40500'},
        20 : {icono: 'build', color: '#E7D123', colorPasado: '#D40500'},
        30 : {icono: 'build', color: '#4BAF29'},
        40 : {icono: 'build', color: '#4BAF29'},
        41 : {icono: 'build', color: '#4BAF29'},
        50 : {icono: 'flag',  color: '#4BAF29'},
        90 : {icono: 'clear', color: '#D40500'}
      },
      itemEncima: 0,
      waitingForLoadTablas: false,
      cambiandoColumnas: false,
      heCambiadoColumnas: false,
      headersTabla: [],
      headers: [
        { text: '', sortable: false, value: 'img', align: 'center', tooltip: false },
        { text: this.$t('m_id'), sortable: true, value: 'id', align: 'center', tooltip: false },
        { text: this.$t('m_visita'), value: 'visitaReferencia', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_estado'), value: 'state', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_tipoSolicitud'), value: 'idSolicitud', sortable: true, align: 'center', tooltip: true },
        { text: this.$t('m_responsable'), value: 'nombreResponsable', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_promocion'), value: 'nombrePromocion', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_ubicacion'), value: 'location', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_localizacion'), value: 'room', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_descripcion'), value: 'description', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_proveedor'), value: 'proveedor', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_oficio'), value: 'profession', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_entrada'), value: 'openDate', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_aviso'), value: 'notificationDate', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_fechaEscrituracion'), value: 'fechaEscrituracion', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_vistoBueno'), value: 'vistoBueno', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_origenCierre'), value: 'origenCierre', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_provinciaProm'), value: 'promProvincia', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_sectorProm'), value: 'sector', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_poblacionInm'), value: 'poblacion', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_valorCodPropios'), value: 'valorCP', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_urgencia'), value: 'urgencia', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_fechaFinPrevisto'), value: 'fechaPrevista', sortable: true, align: 'center', tooltip: false },
      ],
      clickCount: 0,
      clickTimer: null,
      filtrosParaUsar: {},
      textMsgEnviarParteSuccess: '',
      ningunProveedor: null,
      todosConProveedor: null,
      emailsProveedor: [],
      estadosIniciales: [],
      estadosNoIncluidos: ['50'],
      dialogCambiarTipo: false
    }
  },
  created () {
    this.loader = this.$loading.show({
      // Optional parameters
      container: this.fullPage ? null : this.$refs.formContainer,
      canCancel: false,
      onCancel: this.onCancel,
    })
    
    this.getEstados().then(() => {
      this.inicializarFiltros()
      this.inicializarTabla()
      this.loadConFiltros(this.filtrosParaUsar)
      if (this.lastPage) {
        this.customPagination.page = this.lastPage
      }
    })
    
    // this.crearPaginacion()
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getIncidencias: 'incidencias/getIncidencias',
      delIncidencias: 'incidencias/delIncidencias',
      updateIncidenceStatus: 'incidencias/updateIncidenceStatus',
      setFiltros: 'incidencias/setFiltros',
      getEstados: 'incidencias/getStatusTypes',
      getOficios: 'incidencias/getOficios',
      getLocalizaciones: 'incidencias/getLocalizaciones',
      updateIncidenceType: 'incidencias/updateIncidenceType',
    }),
    async filterByEvaluada () {
      try {
        this.filtrosParaUsar = Object.assign({}, this.storeFilters)
        this.filtrosParaUsar.evaluada = this.storeFilters.evaluada
        this.waitingForLoad = true
        this.selectedItems = []
        this.dialog = false
        await this.getIncidencias(this.filtrosParaUsar)
        await this.getOficios()
        await this.getLocalizaciones()
        await this.crearPaginacion()
        this.waitingForLoad = false
        this.loader.hide()
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({ texto: error.message, color: 'error' })
          this.loader.hide()
        }
      }
    },
    accesoTodasIncidencias() {
      return this.idubapi.PERMISOS_ROL_PROVEEDOR_WEB.ACCESO_TODAS_INCIDENCIAS == 1 ? true : false
    },
    permitirModificarEstado () {
      if ( this.rolProveedor ) {
        if ( this.permitirAsignarPromocionesProveedor && this.accesoTodasIncidencias() ) {
          return false
        }
        else {
          return true
        }
      }
      if ( this.rolCliente ) {
        return false
      }
      else {
        return true
      }
    },
    addSuccessMsgEnviarParte () {
      if (this.ningunProveedor) {
        this.textMsgEnviarParteSuccess = this.$t('parteGenerado')
      } else if (this.todosConProveedor) {
        let emailProveedorVacio = this.emailsProveedor.some( (x) => x === "" )
        if(emailProveedorVacio) {
          this.textMsgEnviarParteSuccess = this.$t('parteGeneradoNoEnviado')
        } else {
          this.textMsgEnviarParteSuccess = this.$t('partesGeneradoYEnviado')
        }

      } else {
        this.textMsgEnviarParteSuccess = this.$t('partesGeneradoYEnviado')
      }
      this.addAlert({ texto: this.textMsgEnviarParteSuccess, color: 'success' })
    },
    permitirEliminarSolicitudProveedor() {
      if ( this.rolSupervisor() && this.idubapi.restriccionesCliente.restringirAccesoEliminarIncidenciasPV == 1) {
        return false
      }
      if ( this.rolProveedor) {
        return false
      }
      if (this.rolCliente) {
        return false
      }
      return true
    },
    inicializarFiltros () {
      if (!this.filters) {
        this.filtrosParaUsar = Object.assign({}, this.storeFilters)
        this.filtrosParaUsar.codigoTipoSolicitud = this.codigoTipo
        this.filtrosParaUsar.status = this.$store.state.incidencias.estadosFiltroInicial 
        console.log('this.$store.state.incidencias.estadosFiltroInicial', this.$store.state.incidencias.estadosFiltroInicial)
      } else {
        this.filtrosParaUsar = Object.assign({}, this.filters)
      }
    },
    selectAll (event) {
      this.$refs.tabla.toggleSelectAll(event)
      if (!event) {
        this.selectedItems = []
      }
    },
    getPage (e) {
      this.$store.commit('incidencias/setLastPageVisited', e)
    },
    oneClick (item) {
      this.clickCount++
      if (this.clickCount === 1 && item != null) {
        this.clickTimer = setTimeout(() => {
          this.clickCount = 0
          if (this.selectedItems.length !== 0 && this.selectedItems.some(x => x.id === item.id)) {
            let index = this.selectedItems.indexOf(item)
            this.selectedItems.splice(index, 1)
          } else {
            this.selectedItems.push(item)
          }
        }, 200)
      } else if (this.clickCount === 2) {
        clearTimeout(this.clickTimer)
        this.clickCount = 0
        return false
      }
    },
    async configurarTabla () {
      if (this.cambiandoColumnas && this.heCambiadoColumnas) {
        this.waitingForLoadTablas = true
        localStorage.setItem('headers_080', JSON.stringify(this.headersTabla))
        this.waitingForLoadTablas = false
        this.inicializarTabla()
      } else {
        this.heCambiadoColumnas = false
      }
      this.cambiandoColumnas = !this.cambiandoColumnas
    },
    inicializarTabla () {
      let cabeceras = this.headers
      this.headersTabla = (localStorage.getItem('headers_080')) ? JSON.parse(localStorage.getItem('headers_080')).map(x => {
        let retorno = {...x}
        let encontrado = cabeceras.find(y => x.codigoColumna === y.value)
        retorno.text = (encontrado) ? encontrado.text : ''
        return retorno
      }) : [
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'img', ocultable: true, ocultada: false, orden: 0},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'id', ocultable: true, ocultada: false, orden: 1},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'visitaReferencia', ocultable: true, ocultada: false, orden: 2},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'state', ocultable: true, ocultada: false, orden: 3},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'nombreResponsable', ocultable: true, ocultada: false, orden: 4},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'idSolicitud', ocultable: true, ocultada: false, orden: 5},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'nombrePromocion', ocultable: true, ocultada: false, orden: 6},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'location', ocultable: true, ocultada: false, orden: 7},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'room', ocultable: true, ocultada: false, orden: 8},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'description', ocultable: true, ocultada: false, orden: 9},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'proveedor', ocultable: true, ocultada: false, orden: 10},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'profession', ocultable: true, ocultada: false, orden: 11},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'openDate', ocultable: true, ocultada: false, orden: 12},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'notificationDate', ocultable: true, ocultada: false, orden: 13},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'fechaEscrituracion', ocultable: true, ocultada: true, orden: 14},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'vistoBueno', ocultable: true, ocultada: true, orden: 15},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'origenCierre', ocultable: true, ocultada: true, orden: 16},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'promProvincia', ocultable: true, ocultada: true, orden: 17},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'sector', ocultable: true, ocultada: true, orden: 18},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'poblacion', ocultable: true, ocultada: true, orden: 19},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'valorCP', ocultable: true, ocultada: true, orden: 20},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'urgencia', ocultable: true, ocultada: true, orden: 21},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'fechaPrevista', ocultable: true, ocultada: true, orden: 21},
        
      ].map(x => {
        let retorno = {...x}
        let encontrado = this.headers.find(y => x.codigoColumna === y.value)
        retorno.text = (encontrado) ? encontrado.text : ''
        return retorno
      })
    },
    async setNuevoEstado (val) {
      try {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel,
        });
        await this.updateIncidenceStatus(val)
        await this.loadConFiltros(this.filtrosParaUsar)
        this.addAlert({ texto: this.$t('incidencia_actualizada'), color: 'success' })
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({ texto: error.message, color: 'error' })
          this.loader.hide()
        }
      }
    },
    crearPaginacion () {
      if (this.configValues.configuracion.maxIncidenciasFicha && (this.configValues.configuracion.maxIncidenciasFicha.length > 0 || this.configValues.configuracion.maxIncidenciasFicha.length !== 0)) {
        const parts = 4
        const partial = Math.floor(this.configValues.configuracion.maxIncidenciasFicha / parts)
        for (let i = 0; parts > i; i++) {
          if ( i <= 2 && partial !== 0) {
            this.pagination.push(partial * (i+1))
          } else {
            this.pagination.push(parseInt(this.configValues.configuracion.maxIncidenciasFicha))
          }
        }
      } else {
        this.pagination = [12, 24, 36, 50]
      }
    },
    async loadConFiltros (valores) {
      try {
        this.filtrosParaUsar = valores
        this.waitingForLoad = true
        this.selectedItems = []
        this.dialog = false
        await this.getIncidencias(valores)
        await this.getOficios()
        await this.getLocalizaciones()
        await this.crearPaginacion()
        this.waitingForLoad = false
        this.loader.hide()
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({ texto: error.message, color: 'error' })
          this.loader.hide()
        }
      }
    },
    cancelDialog () {
      this.singleItem = []
      this.selectedItems = []
      this.dialog = false
    },
    goDetail (itemId) {
      this.$router.push({name: 'detalleIncidencia', params: {idIncidencia: itemId, filters: this.filtrosParaUsar}})
    },
    modifyState (item) {
      this.singleItem = []
      this.singleItem.push(item.id)
      this.estadoOrigen = item.statusCode
      this.dialog = true
    },
    modifyStateArray () {
      // comprobamos que todas las incidencias tengan el mismo estado
      var estados = this.selectedItems.map(function(item){ return item.stateId });
      var estadosDiferentes = [...new Set(estados)].length === 1 ? true: false;
      if(!estadosDiferentes) {
        this.addAlert({texto: this.$t('incidencias_mismo_estado'), color: 'error'})
        return
        // tiene estados diferentes, sacamos error
      }
      this.estadoOrigen = this.selectedItems[0].statusCode
      this.singleItem = []
      this.dialog = true
    },
    deleteItem (itemId, estado) {
      if(estado === '10') {
        this.textoConfirmacion = this.$t('seguroEliminarElemento')
        this.dialogDelete = true
        this.itemId = [itemId]
      } else {
        this.addAlert({texto: this.$t('imposible_borrar'), color: 'error'})
      }
    },
    deleteArrayItems () {
      const pendientes = this.selectedItems.find(item => item.statusCode === '10')
      if(pendientes !== undefined) {
        this.textoConfirmacion = this.$t('seguroEliminarElementos')
        this.dialogDelete = true
        this.itemId = this.selectedItems.map(function (item) {
          return item.id
        })
      } else {
        this.addAlert({texto: this.$t('imposible_borrar'), color: 'error'})
      }
    },
    enviarParteArray () {

      const tiposSolicitud = this.selectedItems.map(element => {
        return element.idSolicitud
      })

      const soloIncidencias = tiposSolicitud.every((val) => val === '1')
      if(!soloIncidencias) {
        // hay otros tipos de solicitudes no dejamos generar parte
        this.addAlert({texto: this.$t('parte_solo_incidencias'), color: 'error'})
        return
      }

      const nulosYValidos = this.selectedItems.map(element => {
        return element.proveedor
      })

      this.emailsProveedor = this.selectedItems.map(element => {
        return element.emailProveedor
      })

      if(this.selectedItems.length > 25) {
        // limitamos a 30 el numero de partes de trabajo que se pueden enviar de golpe
        this.addAlert({texto: this.$t('parte_maximo_25'), color: 'error'})
        return
      }

      this.dialogParte = true

      // console.log('nulos - validos: ', nulosYValidos)

      this.ningunProveedor = nulosYValidos.every((val) => val === null)
      this.todosConProveedor = nulosYValidos.every((val) => val !== null)
      const arrayFilter = this.selectedItems.filter((element) => element.proveedor !== null);
      const proveedoresDiferentes = arrayFilter.filter((element) => element.proveedor !== arrayFilter[0].proveedor)
      if(this.inmueblesSeleccionadosDistintos.length > 1 && this.configValues.configuracion.permitirEnvioMasivo === false)
      {
        this.dialogParte = false
        this.dialogEnviarParte  = false
        this.addAlert({texto: 'Hay inmuebles diferentes seleccionados. Para realizar el envío, marque la casilla "permitir envio masivo" en configuración', color: 'error'})
        return
      }
      if(proveedoresDiferentes.length > 0) {
        this.textoTituloDialogParte = 'Proveedores diferentes.'
        this.dialogParte = false
        this.dialogEnviarParte  = false
        this.addAlert({texto: this.$t('proveedor_diferente'), color: 'error'})
      } else if (this.todosConProveedor) {
        this.dialogParte = false
        this.dialogEnviarParte = true
        // todos tienen proveedor
      } else if (this.ningunProveedor) {

        if(this.selectedItems.length > 1) {
          // Si no hay proveedor y ha seleccionado más de una le mostramos un error diciendo que no se puede
          this.dialogParte = false
          this.dialogEnviarParte  = false
          this.addAlert({texto: this.$t('parte_sin_proveedor_max_1'), color: 'error'})
        } else {
          // abro el popup del warning con aviso de ningun proveedor
          this.textoTituloDialogParte = this.$t('incidenciaSinProveedor')
        }
      } else {
        // No se pueden mezclar incidencias con y sin proveedor
        this.dialogParte = false
        this.dialogEnviarParte  = false
        this.addAlert({texto: this.$t('incidencias_con_y_sin_proveedor'), color: 'error'})
        // this.textoTituloDialogParte = 'Algunas incidencias seleccionadas no tienen proveedor asignado. Solo se generarán para ellas Parte de trabajo.'
      }
    },
    importarIncidencias() {
      this.dialogImportar = true
    },
    importarDocumentos() {
      this.dialogImportarDocumentos = true
    },
    cargarFlexmonster () {
      this.flexmonster = !this.flexmonster
    // es-lint-disable-next-line
      new Flexmonster({
        container: 'pivotContainer',
        componentFolder: 'node_modules/flexmonster/',
        toolbar: true,
        licenseKey: licenciaFlexmonster,
        beforetoolbarcreated: customizeToolbar,
        customizeCell: function customizeCellFunction(cell, data) {
          if (data && (data.label == "null" || data.label == 'undefined')) {
            cell.text = "";
          }
          if (data && data.label.indexOf('dit-') > 0) {
            cell.text = cell.text.replace('edit-', '')
          }
        },
        global: {
          localization: require('@/assets/localization/es.json')
        },
        report: {
          dataSource: {
            type: 'json',
            data: this.mapearListaIncidencias(this.getIncidencesList),
          },
          slice: {
            rows: [{
              uniqueName: 'promocion'
            },
            {
              uniqueName: 'direccion'
            },
            {
              uniqueName: 'ubicacion'
            }],
            columns: [{
                uniqueName: 'estado',
                sortOrder: [
                  "Pendiente",
                  "En proceso",
                  "Terminada",
                  "Duplicada",
                  "Cerrada por técnico, pendiente V.B. Cliente",
                  "Cerrado",
                  "Rechazada"
                ]
            }],
            measures: [
              {
                uniqueName: 'Incidencias',
                formula: 'count("estado")',
                aggregation: 'count',
                active: true
              }
            ]
          },
          formats: [{
            name: "", // an empty name allows specifying the default format for all the measures
            thousandsSeparator: ""
          }]
        }
      })
    },
    mapearListaIncidencias (incidencias) {
      return incidencias.map(function (a) {
        let esInmuebleEspecial = a.inmuEspe !== null
        console.log(a)
        return {
          direccion: a.location,
          promocion: a.propertyDevelopment,
          informacionAdicional: a.additionalInformation,
          cliente: a.codigoCliente,
          fechaCierre: a.closeDate,
          idSolicitud: a.idSolicitud,
          costeReal: a.costeReal,
          descripcion: a.description,
          emailCliente: a.emailCliente,
          fechaEstado: a.fechaEstado,
          id: a.referencia, // 266619 - Cambiamos el id por la referencia
          numeroIncidencia: a.incidenceNumber,
          inmuebleEspecial: a.inmuEspe,
          inmueble: a.codigoInmueble,
          visita: a.listNumber,
          movilCliente: a.movilCliente,
          nombreCliente: a.nombreCliente,
          nombrePromocion: a.nombrePromocion,
          fechaNotificacion: a.notificationDate,
          fechaEscrituracion: a.fechaEscrituracion,
          fechaApertura: a.openDate,
          origen: a.origen,
          oficio: a.profession,
          proveedor: a.codigoProveedor,
          ubicacion: a.room,
          estado: a.state,
          idEstado: a.stateId,
          codigoEstado: a.statusCode,
          telefonoCliente: a.telefonoCliente,
          vistoBueno: a.vistoBueno,
          tipoSolicitud: a.tipoSolicitud,
          tipoParte: a.tipoParte,
          tipoReclamacion: a.tipoReclamacion,
          costeEstimado: a.costeEstimado,
          diasEnProceso: a.diasEnProceso,
          predefinida: a.incidenciaPredefinida,
          promProvincia: a.promProvincia,
          poblacion: a.poblacion !== ' ' && a.poblacion !== null && a.poblacion !== '' ? a.poblacion : a.promPoblacion,
          sector: a.sector,
          valorCP: a.valorCP,
          urgencia: a.urgencia,
          fechaFinPrevisto: a.fechaFinPrevisto,
          visitaReferencia: a.visitaReferencia,
          edit: 'edit-' + (esInmuebleEspecial ? a.codigoInmuebleEspecial : a.uhedit)
        }
      })
    },
    confirmarBorrado () {

      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false
      })

      this.delIncidencias(this.itemId)
      .then(() => {
        this.waitingForLoad = false
        this.loadConFiltros(this.filtrosParaUsar)
        this.dialogDelete = false
        this.selectedItems = []
      })
      .catch(e => {
        this.loader.hide()
        this.addAlert({texto: e.message, color: 'error'})
        this.waitingForLoad = false
        this.dialogDelete = false
        this.selectedItems = []
      })
    },
    cargaFichaPDF (tipoFicha) {
      if (tipoFicha === 'C') {
        // si son cerradas, no puede haber incidencias que no esten cerradas
        var noCerradas = this.selectedItems.find(incidencia => incidencia.statusCode !== '50')
        // si hay incidencias no cerradas no sacamos el informe y mostramos error
        if (noCerradas !== undefined) {
          this.addAlert({texto: this.$t('soloIncidenciasCerradas'), color: 'error'})
          return
        }
      }
      this.tipoFicha = tipoFicha
      this.dialogFichaPDF = true
    },
    calculaColorEstado (item) {
      if((item.statusCode === '10' || item.statusCode === '20') && item.imageState.indexOf('red') >= 0) {
        return this.imagenes[item.statusCode].colorPasado
      }
      return this.imagenes[item.statusCode].color
    },
    itemPerPage (val) {
      console.log('val', val)
      this.$store.commit('setItemsPerPage', val)
      if (this.lastItemPerPage == null || val !== this.lastItemPerPage) {
        this.selectedItems =  []
        this.lastItemPerPage = val
      }
    },
    dobleClick (evento, id) {
      if(evento.target.getAttribute("seleccionable") === 'true') {
        this.goDetail(id)
      }
    },
    mouseOver (item) {
      this.itemEncima = item.id
    },
    mouseLeave () {
      this.itemEncima = 0
    },
    getState ( item ) {
      var estados = this.$store.state.incidencias.estados
      var estado = estados.find( o => o.code === item.statusCode) 
      return estado.translates[this.usuario.idioma]
    },
    rolSupervisor () {
      return this.$store.state.login.roles.find(x => x === "PV_SUPERVISOR") !== undefined
    },
    getStyle (value) {
      switch (value) {
        case 'img':
          return 'max-width: 200px;'
        case 'id':
          return 'max-width: 60px;'
        case 'state':
          return 'max-width: 150px;'
        case 'idSolicitud':
          return 'max-width: 50px;'
        case 'nombrePromocion':
          return 'max-width: 150px;'
        case 'location':
          return 'max-width: 150px;'
        case 'room':
          return 'max-width: 150px;'
        case 'description':
          return 'max-width: 120px;'
        case 'proveedor':
          return 'max-width: 120px;'
        case 'profession':
          return 'max-width: 120px;'
        case 'openDate':
          return 'max-width: 120px;'
        case 'notificationDate':
          return 'max-width: 120px;'
      }
    },
    comprobarDeshabilitarParte() {

      const tiposSolicitud = this.selectedItems.map(element => {
        return element.idSolicitud
      })

      const soloIncidencias = tiposSolicitud.every((val) => val === '1')
      return !soloIncidencias
    },
    customSort: function(items, index, isDesc) {
      items.sort((a, b) => {
        if (index[0]=='notificationDate' || index[0] == 'openDate' || index[0] == 'fechaEscrituracion') {
          if (!isDesc[0]) {
              return new Date(this.formateaFecha(b[index])) - new Date(this.formateaFecha(a[index]))
          } else {
              return new Date(this.formateaFecha(a[index])) - new Date(this.formateaFecha(b[index]))
          }
        }
        else {
          if(isNaN(a[index]) && typeof a[index] !== 'undefined'){
            if (!isDesc[0]) {
                return (a[index] || '').toLowerCase().localeCompare((b[index] || '').toLowerCase())
            }
            else {
                return (b[index] || '').toLowerCase().localeCompare((a[index] || '').toLowerCase())
            }
          } else if (typeof a[index] !== 'undefined') {
            if (!isDesc[0]) {
                return a[index] - b[index]
            }
            else {
                return b[index] - a[index]
            }
          }
        }
      });
      return items
    },
    formateaFecha(fecha) {
      return (fecha) ? fecha.split("-").reverse().join("-") : null
    },
    pintarVB(item) {
      return (item.vistoBueno == 1) ? 'Sí' : 'No'
    },
    pintarOrigen(origen) {
      let origenes = [
        {
          codigo: 'SIC',
          descripcion: 'Portal del Cliente'
        },
        {
          codigo: 'WEB',
          descripcion: 'WEB'
        },
        {
          codigo: 'Posventa',
          descripcion: 'APP'
        },
        {
          codigo: 'Prinex',
          descripcion: 'Prinex'
        }
      ]
      let encontrado = origenes.find(obj => obj.codigo == origen)
      return (encontrado) ? encontrado.descripcion : ''
    },
    cabecerasDisponibles(headers) {
      console.log("cabecerasDisponibles")
      console.log(headers)
      if(this.idubapi.motor !== 'SIN_BD') {
        return headers
      } else {
        return headers.filter(item => {
          return item.codigoColumna !== 'fechaEscrituracion' && item.codigoColumna !== 'valorCP'
        })
      }

    },
    traducirLocalizacion (item) {
      if(item.idRoom) {
        let localizacion = this.getterLocalizaciones.find(x => {
          return x.id == item.idRoom
        })
        if(localizacion) {
          return localizacion.translates[this.usuario.idioma] || localizacion.name
        } else {
          return null
        }
      } else 
        return null
      
    },
    traducirOficio (item) {
      if(item.idOficio) {
        let oficio = this.getterOficios.find(x => {
          return x.value == item.idOficio
        })
        if(oficio) {
          return oficio.translates[this.usuario.idioma] || oficio.text
        } else {
          return null
        }
      } else 
        return null
      
    },
    cambiarTipoSolicitud(){
      if(this.selectedItems.length > 1){
        this.addAlert({texto: this.$t('soloUnaIncidencias'), color: 'error'})
        return
      }
      if(this.selectedItems[0].statusCode !== '10'){
        this.addAlert({texto: this.$t('soloIncidenciasPendientes'), color: 'error'})
        return
      }
      this.dialogCambiarTipo = true
    },
    comprobarDeshabilitarCambioTipo() {
      if(this.selectedItems.length > 1){
        return true
      }

      if(this.selectedItems[0].statusCode !== '10'){
        return true
      }

      if(this.selectedItems[0].reabierta !== '0'){
        return true
      }

      return false
    },
    async setNuevoTipo (val) {
      try {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel,
        });
        await this.updateIncidenceType(val)
        await this.loadConFiltros(this.filtrosParaUsar)
        this.addAlert({ texto: this.$t('incidencia_actualizada'), color: 'success' })
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({ texto: error.message, color: 'error' })
          this.loader.hide()
        }
      }
    },
    mostrarProveedorConCodigo(item){
      if((item.codigoProveedor || "") !== "" && (item.descProveedor || "") !== ""){
        return (item.codigoProveedor + " - " + item.descProveedor)
      }else if((item.codigoProveedor || "") !== "" && (item.descProveedor || "") === ""){
        return item.codigoProveedor
      }else if((item.descProveedor || "") !== "" && (item.codigoProveedor || "") === ""){
        return item.descProveedor
      }else{
        return null
      }
    },
    verHistorico() {
      this.dialogImportarDocumentos = false
      this.dialogHistorico = true
    }
  },
  computed: {
    ...mapGetters({
      tiposSolicitud: 'configuracion/getTiposSolicitud',
      getterFiltrosStore: 'incidencias/getFilters',
      rolProveedor: 'login/rolProveedor',
      rolCliente: 'login/rolCliente',
      idubapi: 'login/idubapi',
      getterOficios: 'incidencias/getOficios',
      getterLocalizaciones: 'incidencias/getLocations',
    }),
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    visualizarFiltroEvaluado () {
      return this.configValues.configuracion.visualizarFiltroEvaluado
    },
    translates() {
      if (this.$store.state.tiposSolicitud.translates) {
        return this.$store.state.tiposSolicitud.translates;
      }
      return [];
    },
    headersTablaOrden: {
      get () {
        return this.headersTabla
      },
      set (value) {
        this.headersTabla = value.map((x, i) => {
          x.orden = i
          return x
        })
        this.heCambiadoColumnas = true
      }
    },
    optionsSelectEvaluated () {
      let options = []
      options.push({value: '', text: this.$t('verIncidencia.datosIncidencia.todas') }) 
      options.push({value: '0', text: this.$t('verIncidencia.datosIncidencia.noEvaluado') }) 
      options.push({value: '1', text: this.$t('verIncidencia.datosIncidencia.evaluado') }) 
      return options
    },
    countSelected () {
      return this.selectedItems.length === 0
    },
    permitirAsignarPromocionesProveedor() {
      return this.configValues.configuracion.permitirAsignarPromocionesProveedor
    },
    storeFilters: {
      get () {
        return this.getterFiltrosStore
      },
      set (value) {
        this.setFiltros(value)
      }
    },
    getActor () {
      return this.$store.state.login.id
    },
    lastPage () {
      return this.$store.state.incidencias.lastPage
    },
    headersFiltrados () {
      let headers = this.headers.map(h => {
        let retorno = {...h}
        retorno.class = []
        retorno.classTd = []
        retorno.orden = 999
        retorno.ocultable = false
        retorno.ocultada = false
        if (h.value) {
          let hTabla = this.headersTabla.find(x => x.codigoColumna === h.value)
          if (hTabla) {
            retorno.orden = hTabla.orden
            retorno.ocultable = hTabla.ocultable
            retorno.ocultada = hTabla.ocultada
            if (h.class) {
              retorno.class.push(...h)
            }
            if (hTabla.ocultable && hTabla.ocultada && !this.cambiandoColumnas) {
              retorno.class.push('d-none')
              retorno.classTd.push('d-none')
            }
          }
        }
        return retorno
      }).filter(x => x.ocultada === false).sort((a, b) => a.orden - b.orden)
      return headers
    },
    getIncidencesList () {
      return this.$store.state.incidencias.listaIncidencias
    },
    configValues () {
      return this.$store.state.configuracion
    },
    textoTipoSolicitudes () {
      if (!this.filters || !this.filters.codigoTipoSolicitud) {
        return this.$t('incidencias')
      } else {
        const aux = this.tiposSolicitud.find(x => x.codigoTipoSolicitud.toString() === this.filters.codigoTipoSolicitud.toString())
        return aux !== undefined ? aux.descripcionTipoSolicitud : this.$t('incidencias')
      }
    },
    inmueblesSeleccionadosDistintos() {
      if(this.selectedItems.length != 0){
      let inmuebles = this.selectedItems.map(x => {
          return {
            inmueble: x.inmueble
          }
        })
      let arr = []
      inmuebles.forEach(x => {arr.push(x.inmueble)})
      let unique = [...new Set(arr)]
      return unique
      }
      else {
        return []
      }
    },
    customPagination() {
      // let _items = localStorage.getItem('lasItemPerPage', 74)
      //console.log(_items)
      let _items = this.$store.state.itemsPerPage
      
      if(_items === 0 || _items === null) {
        _items = this.pagination[0] 
      }
      return {
        page: 1,
        itemsPerPage: _items ?? this.pagination[0] 
      }
    },
  },
  watch: {
    getIncidencesList () {
      this.selectedItems = []
    },
  },
  destroyed () {
    document.documentElement.classList.remove('showScrollbar2')
  }
}

function customizeToolbar (toolbar) {
  var tabsOriginales = toolbar.getTabs()
  var tabsDeseadas = ['Save', 'Export', 'Grid', 'Charts', 'Format', 'Options', 'Fields', 'FullScreen']
  toolbar.getTabs = function () {
    var tabs = []
    _.each(tabsOriginales, function (tab) {
      if (tabsDeseadas.indexOf(tab.title) >= 0) {
        tabs.push(tab)
      }
    })

    return tabs
  }
}
</script>

<style scoped>


  .nowrap {
    white-space: pre-wrap
  }
  .no-margin {
    margin: 0px !important;
  }
  /* .theme--light.v-table tbody tr:hover:not {
    background: red !important;
  } */
  .itemSelected tr:hover:not(.v-datatable__expand-row) {
    background: #ddecff !important;
  }
  .v-btn--floating.v-btn--small {
    height: 35px;
    width: 35px;
    margin: 0 !important;
  }
  .v-data-table {
    max-width: 100%;
    min-width: 100%;
    border: 1px solid #d6d6d6;
  }
  .clickable {
    cursor: pointer;
    text-align: center;
    padding: .1em;
  }
  .v-data-table-header-mobile__wrapper {
    width: 85px !important;
  }
  .clickable:hover {
    background: rgba(80, 200, 255, .2);
    border-radius: 50%;
  }
  .fade-enter-active, .fade-leave-active {
    text-align: center;
    visibility: visible;
    opacity: 1;
    transition: opacity 0.2s ease;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    text-align: center;
    visibility: hidden;
    opacity: 0;
  }
  .lista-tooltip {
    background: transparent;
  }

  .v-tooltip {
    max-width: 500px;
  }
  .v-tooltip__content {
    border: 2px solid #d6d6d6;
    background: rgba(250, 250, 250, .9) !important;
    color: black;
    max-width: 500px;
    /* left: 100px !important;
    top: 100px !important; */
  }
  .recortarStyle {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .d-none {
    display: none !important;
  }
  .claseLocation {
    white-space: pre-wrap;
  }
.badge {
  background-color: #feaeae;
}
.container {
  padding: 30px!important;
}
</style>
